export default __webpack_public_path__ + "static/media/fake-hr.7eb5dfbb.png";